module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page7",
      "title": "7"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("1")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-5",
      "title": "1 Hard Thoughts About God"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("Hard Thoughts About God"), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("Not that I am (I think) in much danger of ceasing to believe in God. The real danger is of coming to believe such dreadful things about Him. The conclusion I dread is not “So there’s no God after all,” but “So this is what God’s really like. Deceive yourself no longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_vm._v("C. S. Lewis, "), _c('i', [_vm._v("A Grief Observed")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("The L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" is near to the brokenhearted and saves the crushed in spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Psalm+34%3A18&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Psalm 34:18")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_vm._v("As the bridegroom rejoices over the bride,so shall your God rejoice over you.")]), _vm._v(" "), _c('p', {
    staticClass: "epi_source"
  }, [_c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Isaiah+62%3A5&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Isaiah 62:5")])]), _vm._v(" "), _c('p', {
    staticClass: "dingbat"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/dingbat_c.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "first-words"
  }, [_vm._v("This book will make no attempt")]), _vm._v(" to defend God. I will not try to justify God or explain away the physical suffering in this world. Instead, I wrestle with nagging questions about our lives, our purpose, and our "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page8",
      "title": "8"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("struggles. How should we live in the midst of this pain-soaked world? How do we relate to the God whose world this is?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If you are looking for a book that boasts triumphantly of conquest over a great enemy or gives a detached philosophical analysis that neatly solves an absorbing problem, this isn’t it. Instead, this book aims to invite you into a larger conversation, a conversation greater than my family, and a struggle bigger than your pain and doubt. For while our pain, or the suffering of those we love, may cause us to feel isolated, these challenges remind us that we are actually part of the much larger stream of humanity. A stream that is all too familiar with physical pain.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Admitting the Complexity of Pain")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("As a result of wrestling with her own suffering, or “affliction” as she called it, philosopher and political activist Simone Weil wrote that such experiences have three dimensions that cannot be forgotten: physical, psychological, and social."), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1508",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("1")])]), _vm._v(" She emphasizes the importance of solidarity, the danger of isolation, and the crippling effects of despair that threaten those in pain. Her instinct to approach suffering in a way that attempts to weave together these various dimensions of our lives appears correct to me."), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1509",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Physical suffering often affects how we relate to God and others. For example, when a person’s body is completely worn out from physical pain, he or she can perceive God as cruel. Talk of God’s kindness can ring hollow, or worse, it can sound like a nauseating joke. The condition of our bodies does influence how we understand God and his ways. If bright lights or loud noises trigger chronic migraines for some people, wouldn’t they hesitate to join worship services that use those features? Avoiding bright lights and pulsating music may not testify to their lack of spirituality but to their survival instincts. A thundering organ may cultivate reverence for some, but it might foster painful physical reactions for others. Pain in our body often influences how we relate to others. While avoiding certain worship services because of physical reactions may appear irreligious to people who enjoy those services, this impression fails to understand the challenges of unrelenting discomfort.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("One man who suffers chronic pain explained his common struggle on Sunday mornings at church: “I feel guilty for having to sit during ‘praise’ "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page9",
      "title": "9"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("time. I know how it can look. I don’t have any visible physical ‘condition.’ So, in addition to the physical pain that I am having to endure while trying to worship God, I am often wrestling with my own desire to not appear ‘irreligious.’” What some may imagine as signs of cool aloofness may in fact be acts of self-preservation and cries of despair. But we must, as Simone Weil urges us, remember how the social, psychological, and physical are woven together, mindful of how these circumstances also inform our relationship to God. These kinds of difficulties can roll over us like waves of the sea, creating particular and often awkward challenges for the believer and the church.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Limits are part of the everyday life of those with chronic pain. Sufferers may have to choose between a friend’s engagement party and grocery shopping because they don’t have the stamina to do both."), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1510",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("3")])]), _vm._v(" This doesn’t make them antisocial. It doesn’t mean they are unloving. Their physical suffering places stringent limits on them every day. Limits that isolate and exhaust.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As we examine our suffering, we must do our best to maintain a holistic perspective. We must not pit the body against the spirit, the mind against the heart, the individual against the community. For our struggle is not ultimately with a single side of suffering but with how it affects us in our totality: from our relationships to our faith, from our bodies to our hope, from our mourning to our love. Central to the complexity of our pain is how it can affect our view of God.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("Tempted to Think Ill of God")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Christians, perhaps even more than those without faith in a personal and loving God, can feel not just alone but abandoned during times of difficulty. It is one thing for sufferers to cry out to the great Unknown, echoing the unsettling words of Stephen Crane:")]), _vm._v(" "), _c('p', {
    staticClass: "blockfirst"
  }, [_vm._v("A man said to the universe:")]), _vm._v(" "), _c('p', {
    staticClass: "blockfirst"
  }, [_vm._v("“Sir, I exist!”")]), _vm._v(" "), _c('p', {
    staticClass: "blockfirst"
  }, [_vm._v("“However,” replied the universe,")]), _vm._v(" "), _c('p', {
    staticClass: "blockfirst"
  }, [_vm._v("“The fact has not created in me")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("A sense of obligation.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1511",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page10",
      "title": "10"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("Yet for the saint who confesses the personal God of Abraham, Isaac, Jacob, and Mary, such moments of despair can bring the fear of divine indifference, rejection, or judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("One of the most powerful temptations Christians face as they go through suffering is, to borrow a phrase from John Owen, to have “hard thoughts” about God."), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1512",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("5")])]), _vm._v(" By “hard thoughts” this Puritan theologian does not have in mind our honest questions that naturally arise amid struggles. We all have honest questions as we stand before God: "), _c('i', [_vm._v("Why? How come? What does this mean? When will it end?")]), _vm._v(" Such questions are not only understandable but healthy. Despite widespread misperceptions, Christian spirituality is not stoicism. Heartfelt cries and existential questions operate at the core of healthy theology, and suppressing them is more hurtful than a confession of ignorance. We will discuss this later when we get to the role of longing and lament. But what Owen has in mind is different, which is why these might be called “temptations” rather than merely honest struggles.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Whether first fostered from painful childhood experiences, heavy-handed preaching, or something else, we often imagine God in deeply problematic ways."), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1513",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("6")])]), _vm._v(" When experiences of physical suffering persist, it is all too common to find ourselves plagued by distorted perceptions of God, making him appear tyrannical or even demonic. Such “hard thoughts” are temptations because they can lead us to ultimate despair and away from communion with the loving Lord. They are temptations because our suffering and struggle entice us to think ill of God, to imagine him cruel and brutish. As Owen comments, we are “apt to have very hard thoughts of him,—to think he is always angry, yea, implacable; that it is not for poor creatures to draw nigh to him.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1514",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("7")])]), _vm._v(" Such hard thoughts are destructive because they hide God from us, running counter to how the Father actually views his children:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The Lord takes nothing worse at the hands of his [children], than such hard thoughts of him, knowing full well what fruit this bitter root is like to bear,—what alienations of heart,—what drawings back,—what unbelief and tergiversations [i.e., turning one’s back] in our walking with him. How unwilling is a child to come into the presence of an angry father!"), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1515",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("My wife describes feeling at times that God has more important things to deal with than one woman’s pain. The needs of a suffering world require his "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page11",
      "title": "11"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v("full attention, and she just needs to toughen up. Such thoughts, as she would say, are incorrect and only drive the sufferer to isolation from God. But sufferers commonly find these thoughts creeping in, twisting their image of the divine. God’s concern about such hard thoughts arises not because he cannot answer our questions or becomes defensive. No, they concern God because they keep us far from him.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("This is the frame of mind that isolates us, distorting our image of the Creator and keeping us from knowing his compassion. Thus the sufferer, instead of seeing the Father, whose whole inclination toward us is love, mercy, and desire to commune with his children, sees in his place a false image of an angry, distant, austere being who can never be satisfied or happy. These false perceptions of the sufferers “are apt to impair and weaken their love towards him and delight in him.”"), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1516",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("9")])]), _vm._v(" When these misconceptions take hold, they throw cold water on the small embers of our love for God.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("How can believers tossed and blown by the storms of life "), _c('i', [_vm._v("not")]), _vm._v(" succumb to false images of God? This question requires that we deepen our view of who God actually is and thus leave behind our own fears and the conceptual baggage about God we have casually acquired. Owen reinforces the claim that God, instead of being a harshly demanding and disappointed accountant in the sky, is in fact our own Father who, in his delight, always keeps a near and tender presence:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Is there any thing possible more endearing to the heart of a creature than to hear such a testimony as that, Zeph. 3:17, concerning the stability of the love of God, and its excellency, “The L"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ORD")]), _vm._v(" thy God in the midst of thee is mighty; he will save, he will rejoice over thee with joy; he will rest in his love, he will joy over thee with singing?” God’s resting in his love towards his saints fixes their souls in their love to him."), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1517",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Our legitimate dislike of shallow sentimentality about God raises our suspicion about this vision of God joyfully singing over his people. Yet these words come not from a sappy greeting card or a people-pleasing pastor but from the deep prophetic soul of Zephaniah, who knew God’s judgment on corruption and God’s concern over issues of injustice and neglect; he also knew of God’s faithfulness to his people and the hope that it held out. Our inclination to dismiss this imagery of God singing as meaningless "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page12",
      "title": "12"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v("sentimentality is not a sign of our willingness to be realistic but of preconceptions of God informed by unbiblical impulses, such as those acquired from bad television and sloppy preaching. Take careful note of the places that the Bible’s descriptions of God make us uncomfortable, and ask why they do so. These observations reveal broader problems in our thinking and attitudes. These are the places to dig in and rebuild.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Zephaniah’s words call us to reconsider what we imagine God to be like, to ask how it might be possible that he rejoices over us with singing. Taylor is a boy who has been exceptionally empathetic since his earliest years. At twelve his heart remained tender and sensitive but also vulnerable to other people’s pain and sadness. One Sunday after watching just the first part of "), _c('i', [_vm._v("The ")]), _c('i', [_vm._v("Fellowship of the Ring")]), _vm._v(", the preteen awoke around midnight because of the frightening images of shadowy horsemen and twisted orcs that now flitted through his imagination. He saw Frodo’s fear and darkness hovering over the land. He wept. He tried to console himself, to bring himself courage, but apparently it would not come. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, upon hearing the tears his father, Michael, went upstairs in the middle of the night. Michael prayed, he rubbed his son’s back, and then he slowly moved toward the door. When his father tried to leave, comfort and sleep also instantly departed from Taylor. So the father returned, and this time he simply sat over his boy and sang softly. Evidently as long as he sang, the boy was able to sleep. As soon as he would try to cease from his serenading, the boy awoke. So the father stayed, he sang, and he eventually just nestled in next to the boy. The father didn’t sleep much that night, but the child fell into a deep slumber, both calm and grateful simply for the presence that was beside him and the voice that hung over him. ")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("How is it that the heavenly Father, who is consistently described as “full of compassion,” might not show such concern for his daughters and sons? Why do we find it so difficult to embrace Zephaniah’s tender image? Isaiah similarly drew on such imagery, only changing the metaphor from a Father singing over his children to the promise of a husband delighting in his wife: “As the bridegroom rejoices over the bride, so shall your God rejoice over you” ("), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Is+62%3A5&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Is 62:5")]), _vm._v("). Why does this make us so uncomfortable?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("How does God look upon us in our weakness, even in our sin? Is God really angry or wrathful with us, his children? His bride? What picture of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page13",
      "title": "13"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v("God is really warranted by the Scriptures? How do these passages like "), _c('a', {
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Zephaniah+3%3A17;+Isaiah+62%3A5&version=ESV",
      "target": "_blank"
    }
  }, [_vm._v("Zephaniah 3:17 and Isaiah 62:5")]), _vm._v(" intersect our own experience? How can we then deal with the “hard thoughts” that tempt us, especially in our suffering? How do we develop a profound and affectionate trust of God rather than a sense of alienation? Our journey is to learn why such hard thoughts don’t reflect the triune God. Our hope is to learn to hear him singing over us, to trust his presence in the middle of the pain. Some will immediately object that this is wishful thinking based on a few obscure verses here and there. However, we will see that we are not talking about a few scattered biblical texts but diving into the heart of the gospel, the heart of the good news discovered in the Messiah. Only here will we unquestionably discover the very heart of God.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("To understand God and his relationship to our pain, we will need to examine the case of Jesus of Nazareth, a man who walked the dusty roads of Galilee over two thousand years ago. Only by listening to his words and by following the movement of his life, death, resurrection, and ascension might our very human struggle be seen in different light. Because he was and is God’s revelation of himself to us, it only makes sense to start there. In this endeavor it is to be hoped that our view of the God of heaven and earth will deepen beyond our current understanding. But to see Jesus clearly we need to stop defending our preconceived notions of who God is.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If you are plagued by “hard thoughts” of God, don’t give up. No easy answer will suffice, and no pill can make everything instantly well. Still, I hope that what follows will give genuine encouragement and glimpses into the heart of God. Along the way we will be reminded not only how much we need God but how much we need his people—we need each other. This, as we will see, informs how we might start to address questions about our suffering.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("Where We are Going: Overview of the Rest of the Book")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("My goal is not to explain away human suffering on the one hand or the goodness of God on the other. Instead, we continue on a journey of faith, an encounter with the living God, our Creator and Redeemer. This is the story of the God who is more holy than we can imagine and more near than we dare believe. This is the God whose perfections provoke awe, yet whose movement of condescension frightens us in its humility. This is the story of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page14",
      "title": "14"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v("Emmanuel, the story of the gospel, and the story of how those who know this Lord can live amid the rubble, the dark questions, and the daunting fears. This is the story of what it means to be a creature living with hope in a broken world—not a hypothetical world but this world, filled with beauty and tears, with laughter and ache.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As we proceed, I hope to keep things more manageable by narrowing our discussions with two assumptions. First, this book specifically addresses "), _c('i', [_vm._v("Christians")]), _vm._v(" who suffer, and not the more general—and profoundly legitimate—questions about universal human suffering. While I will be speaking of suffering as experienced by Christians, I believe it relates to all people who roam the earth. In this world the reality of suffering afflicts all humanity; in fact its universal nature serves as a great equalizer. We all share the experience of suffering. Yet, since I do not aim to solve the problem of suffering but to talk about how a Christian might live in the midst of it, I will keep Christians as my primary audience.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Second, the suffering discussed here will normally mean the "), _c('i', [_vm._v("suffering associated with serious illness or physical pain")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/23_notes#_idTextAnchor1518",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("11")])]), _vm._v(" Various hurts and difficulties often arise from this form of suffering. Physical pain normally affects us in holistic ways, from our emotions to our relationships, from our work to our leisure, from our private lives to our public engagements. All of those things are relevant to properly addressing suffering associated with physical pain. We will ask, What does it look like for the Christian, the saint, to go through the valley of such distress? I hope and believe that this book has application for dealing with all sorts of suffering and not merely the physical variety: many who have heard some of this material have let me know that while I focus on suffering associated with physical pain, there is real relevance for Christians in different situations (e.g., raised in an abusive home). My prayer is that this book will prove helpful to many, whatever form of suffering they might be enduring. Nevertheless, to keep this book shorter and more focused, the scope of the conversation here is intentionally limited. Therefore, while I will keep in mind larger issues related to various forms of suffering (e.g., injustice inflicted on us by hostile agents, etc.), I will focus on particular challenges associated with physical pain. Also, by approaching this topic through the particular lens of bodily suffering, thus emphasizing our physicality, I believe our understanding of the Christian story may take on fresh meaning and power.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page15",
      "title": "15"
    }
  }), _vm._v("In the chapters that follow we will look at the limitations of easy answers and the tension between our longings for peace and our laments that something is wrong. Next, we explore what it means to be embodied creatures and what this tells us about ourselves, our expectations, and even what kind of relationship we might expect with the Creator. Doubts about our body’s value remain a significant stumbling block to genuine Christian spirituality, and this misunderstanding is often intensified by debilitating pain. We then turn to the strangeness of God as displayed in Jesus of Nazareth. Only by looking to this man can we reorient our experience of suffering in a way that is truly Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We will go on to see that those who are part of the body of Christ live life together, a life of faith, hope, and love. Here we discover a pattern for Christian discipleship that allows for genuine struggle, communal support, and transformative affection. We wrestle and rest in this community. Next, I offer some reflections on the place of"), _c('i'), _vm._v("pain and confession. As surprising as it may seem, confession becomes a particularly life-giving necessity for those with physical pain: here confession and the community come together, drawing us back to Christ. Finally, I conclude with some particular pastoral reflections that I hope will prove practical to those who suffer or are caregivers. To understand how all of this works together, however, we must cover a fair amount of terrain. Like a rewarding view from the top of a mountain, we have to climb the trail to get there and marvel at the beauties of the mysteries along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page16",
      "title": "16"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5384ae36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/09_ch1.vue
// module id = 75
// module chunks = 0